import { Row } from 'react-bootstrap';
import styled from 'styled-components';

export const ExtraFieldRow = styled(Row)`
  display: flex;
  align-items: center;

  margin-top: 0.5rem;

  & > div:last-child {
    display: flex;
    justify-content: flex-start;
    & > button {
      cursor: pointer;
      padding: 0.25rem 0.5rem;
      background: transparent;
      display: flex;
      align-items: center;
    }
  }
`;
